import { render } from "./NotificationCableBridge.vue?vue&type=template&id=2f6d1aeb&lang=pug"
import script from "./NotificationCableBridge.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationCableBridge.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__